<form [formGroup]="agreementForm">
    <app-form-section>
        <!-- <app-form-row-header [title]="'FEATURES.SUMMARY.TITLE' | translate" /> -->
        <div class="action-buttons">
            <button (click)="download()" class="icon" [ngClass]="{ loading: generatingPdf }">
                <span>{{ 'BUTTONS.DOWNLOAD_PDF' | translate }}</span>
                <span class="material-symbols-rounded trailing" aria-hidden="true"> download </span>
            </button>
            <button (click)="printPDF()">
                {{ 'BUTTONS.PRINT' | translate }}
                <span class="material-symbols-rounded trailing" aria-hidden="true"> print </span>
            </button>
            <!-- <button (click)="printSection('summary-content')">Print 2</button> -->
        </div>
    </app-form-section>
</form>

<div id="print-content" [class.print-mode]="generatingPdf">
    <div id="summary-content">
        <div class="box part">
            <div class="header">
                <h5>{{ 'FEATURES.SUMMARY.PART_1' | translate }}</h5>
                <div class="title-row">
                    <span class="material-symbols-rounded" aria-hidden="true"> corporate_fare </span>
                    <div class="title">
                        <h3>{{ customer?.name }}</h3>
                        {{ customer?.organizationNo }}
                    </div>
                </div>
            </div>
            <div class="details">
                <div class="column">
                    <strong> {{ 'FEATURES.SUMMARY.ADDRESS' | translate }} </strong><br />
                    {{ customer?.address }}<br />
                    {{ customer?.zipCode }} {{ customer?.city }}
                </div>

                <div class="column">
                    <strong> {{ 'FEATURES.SUMMARY.CONTACT_PERSON' | translate }} </strong><br />
                    {{ user?.firstName }} {{ user?.lastName }}<br />
                    {{ user?.email }}<br />
                    {{ user?.phone }}
                </div>
            </div>
        </div>

        <div class="box part">
            <div class="header">
                <h5>{{ 'FEATURES.SUMMARY.PART_2' | translate }}</h5>
                <div class="title-row">
                    <span class="material-symbols-rounded" aria-hidden="true"> handshake </span>
                    <div class="title">
                        <h3>{{ counterpart?.companyName }}</h3>
                        {{ counterpart?.organizationNo }}
                    </div>
                </div>
            </div>
            <div class="details">
                <div class="column">
                    <strong> {{ 'FEATURES.SUMMARY.ADDRESS' | translate }} </strong><br />
                    {{ counterpart?.address }}<br />
                    {{ counterpart?.zipCode }} {{ counterpart?.city }}
                </div>

                <div class="column">
                    <strong> {{ 'FEATURES.SUMMARY.CONTACT_PERSON' | translate }} </strong><br />
                    {{ counterpart?.fullname }}<br />
                    {{ counterpart?.email }}<br />
                    {{ counterpart?.phone }}<br />
                    {{ counterpart?.linkedin }}<br />
                    {{ counterpart?.website }}
                </div>
            </div>
        </div>
    </div>

    <div class="box">
        <div class="header">
            <div class="title-row">
                <span class="material-symbols-rounded" aria-hidden="true"> contract </span>
                <div class="title">
                    <h3>{{ detailsForm.controls.name.value }}</h3>
                    {{ detailsForm.controls.agreementNo.value }}
                </div>
                <div class="value">
                    {{ paymentForm?.controls.value.value }} SEK
                    <span
                        [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.VALUE' | translate"
                        class="material-symbols-rounded"
                        aria-hidden="true"
                    >
                        help
                    </span>
                </div>
            </div>

            <div class="status">
                <span class="material-symbols-rounded" aria-hidden="true"> info </span>
                {{ 'FEATURES.AGREEMENTS.STATUS.' + getStatus() | translate }}
            </div>
            <p>{{ detailsForm.controls.description.value }}</p>

            <div class="timeline">
                <!-- Timeline Component -->
                <app-agreement-timeline
                    [validFrom]="periodForm.controls.validFrom.value"
                    [noticeDate]="noticeDate"
                    [validTo]="periodForm.controls.validTo.value"
                    [terminationDate]="periodForm.controls.terminationDate.value"
                    [validToAfterExtension]="validToAfterExtension"
                ></app-agreement-timeline>
            </div>
        </div>

        <div class="details">
            <div class="column">
                <strong>{{ 'FEATURES.SUMMARY.AGREEMENT_DETAILS' | translate }}</strong
                ><br />
                <div class="row">
                    <div>{{ 'FEATURES.AGREEMENTS.NEW_AGRREMENT_TITLE' | translate }}:</div>
                    <div>
                        {{
                            'FEATURES.AGREEMENTS.AGREEMENT_TYPES.' + detailsForm.controls.agreementTypeId.value
                                | translate
                        }}
                    </div>
                </div>
                <div class="row">
                    <div>{{ 'FEATURES.SUMMARY.AREA' | translate }}:</div>
                    <div>{{ detailsForm.controls.area.value }}</div>
                </div>
                <div class="row">
                    <div>{{ 'FEATURES.SUMMARY.CATEGORY' | translate }}:</div>
                    <div>{{ detailsForm.controls.category.value }}</div>
                </div>
                <div class="row">
                    <div>{{ 'FEATURES.SUMMARY.AGREEMENT_CREATED' | translate }}:</div>
                    <div>{{ agreementCreated | dateTime: 'yyyy-MM-dd' | replaceEmptyString }}</div>
                </div>
                <div class="row" *ngIf="periodForm?.controls.replacedAgreementName.value">
                    <div>{{ 'FEATURES.SUMMARY.REPLACED' | translate }}:</div>
                    <div>
                        <a
                            class="replaced-agreement-link"
                            (click)="goToReplacedAgreement()"
                            (keypress)="goToReplacedAgreement()"
                            tabindex="0"
                        >
                            {{ periodForm.controls.replacedAgreementName.value }}
                        </a>
                    </div>
                </div>
            </div>

            <div class="column">
                <strong>{{ 'FEATURES.SUMMARY.TERMS' | translate }}</strong
                ><br />
                <div class="row" *ngIf="periodForm?.controls.commitmentPeriodTypeId.value > 0">
                    <div>{{ 'FEATURES.SUMMARY.COMMITMENT_PERIOD' | translate }}:</div>
                    <div>
                        {{ periodForm.controls.commitmentPeriodTypeId.value }}
                        {{
                            periodForm.controls.commitmentPeriodTypeId.value > 0 ? ('GENERAL.MONTHS' | translate) : '-'
                        }}
                    </div>
                </div>
                <div class="row">
                    <div>{{ 'FEATURES.SUMMARY.VALID_FROM_TO' | translate }}:</div>
                    <div>
                        {{ getDateString(periodForm.controls.validFrom.value) }} /
                        {{ periodForm.controls.validTo.value ? getDateString(periodForm.controls.validTo.value) : '-' }}
                    </div>
                </div>
                <div class="row">
                    <div>{{ 'FEATURES.AGREEMENTS.LAST_DATE_FOR_NOTICE' | translate }}:</div>
                    <div>{{ lastDateForNotice ? lastDateForNotice : '-' }}</div>
                </div>
                <div class="row" *ngIf="periodForm.controls.noticePeriod.value">
                    <div>{{ 'FEATURES.SUMMARY.NOTICE_PERIOD' | translate }}:</div>
                    <div>
                        {{ periodForm.controls.noticePeriod.value }}
                        {{
                            periodForm.controls.noticePeriodTypeId.value === 0
                                ? ('GENERAL.DAYS' | translate)
                                : ('GENERAL.MONTHS' | translate)
                        }}
                    </div>
                </div>
                <div class="row">
                    <div>{{ 'FEATURES.SUMMARY.AUTO_RENEWAL' | translate }}:</div>
                    <div>{{ periodForm.controls.periodAfterExtension.value > 0 ? 'Ja' : 'Nej' }}</div>
                </div>
                <div class="row" *ngIf="paymentForm?.controls.paymentTerms.value">
                    <div>{{ 'FEATURES.SUMMARY.PAYMENT_TERMS' | translate }}:</div>
                    <div>{{ paymentForm?.controls.paymentTerms.value }} {{ 'GENERAL.DAYS' | translate }}</div>
                </div>
                <div class="row" *ngIf="paymentForm?.controls.invoiceIntervalId.value">
                    <div>{{ 'FEATURES.SUMMARY.BILLING' | translate }}:</div>
                    <div>
                        {{
                            'FEATURES.AGREEMENTS.INVOICE_INTERVALS.' + paymentForm?.controls.invoiceIntervalId.value
                                | translate
                        }}
                    </div>
                </div>

                <!-- {{ 'FEATURES.SUMMARY.TERMINATION_DATE' | translate }}: {{ detailsForm.controls.signer.value }}<br /> -->
            </div>
            <div class="column">
                <strong>{{ 'FEATURES.SUMMARY.REMINDERS' | translate }}</strong
                ><br />
                <div class="row">
                    <div>{{ 'FEATURES.SUMMARY.REMINDER_RECIPIENTS' | translate }}:</div>
                    <div>{{ getReminderRecipients() }}</div>
                </div>
                <div class="row">
                    <div>{{ 'FEATURES.SUMMARY.REMINDER_START_DATE' | translate }}:</div>
                    <div>{{ reminderStartDate }}</div>
                </div>
                <div class="row">
                    <div>{{ 'FEATURES.SUMMARY.REMINDER_INTERVAL' | translate }}:</div>
                    <div>{{ numOfReminders }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
